import { useState } from "react";
import { AscButtonShareCommonPropsI } from "../AscButtonShare.type";
import styles from "./AscButtonShareCopyLink.module.scss";
import classNames from "classnames";
import { CheckMarkIcon, CopyIcon } from "../../AscIcons";

function AscButtonShareCopyLink({
  className,
  label = "Copy Link",
  link,
}: AscButtonShareCommonPropsI) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };
  return (
    <button
      className={classNames(className, styles.element, {
        [styles.copied]: copied,
      })}
      onClick={handleCopy}
    >
      {copied ? (
        <CheckMarkIcon
          className={styles.icon}
          data-testid={"test-icon-copied"}
        />
      ) : (
        <CopyIcon className={styles.icon} data-testid={"test-icon-copy"} />
      )}
      {label}
    </button>
  );
}

export default AscButtonShareCopyLink;
